import React from 'react';
import { Link } from 'react-router-dom';
import { formatDistanceToNowStrict } from 'date-fns';
import Tooltip from '@atlaskit/tooltip';
import './widget-items.scss';

interface BillingAccountWidgetItemType {
  url: string;
  timestamp: number;
  metadata?: {
    transactionAccountNumber: string;
    displayName: string;
  };
  entityName?: string;
}
/**
 * Component for Billing account Widget on the Search page
 * @constructor
 */
const BillingAccountWidgetItemsComponent = ({ url, timestamp, metadata }: BillingAccountWidgetItemType) => {
  return (
    <div className="flex justify-space-between pv-12 billing-account-widget-item">
      <div className="left-side">
        <div className="content">
          <Link to={url}>
            <div className="flex">
              <Tooltip content={metadata?.transactionAccountNumber} position="bottom-start" tag="span">
                <div className="title">{metadata?.transactionAccountNumber}</div>
              </Tooltip>
            </div>
          </Link>
        </div>
        <div className="content">
          <div className="sub-title">{metadata?.displayName}</div>
        </div>
      </div>
      <div className="right-side">
        <div className="content">
          <div className="timestamp">{formatDistanceToNowStrict(new Date(timestamp), { addSuffix: true })}</div>
        </div>
      </div>
    </div>
  );
};

export const BillingAccountWidgetItem = React.memo(BillingAccountWidgetItemsComponent);
